/**
 * cookie 数据存储
 * 需要自动过期的可以使用cookie
 */

import Cookies from 'js-cookie'
import config from '@/config'

// 过期时间
const { cookieExpires  } = config


//token的key
export const TOKEN_KEY = 'TZXH_OA_TOKEN'

/**
 * 获取token
 */
export const getToken = () => {
    const token = Cookies.get(TOKEN_KEY)
    if (token) return token
    else return false
}

/**
 *设置toke和过期时间 
 * @param {*} token 
 */
export const setToken = (token) => {
    Cookies.set(TOKEN_KEY, token, { expires: cookieExpires || 1 })
}



// WEBPACK FOOTER //
// ./src/utils/libs.js